import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 6,
	height: 18,
	viewBox: "0 0 6 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3018_125375)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M2.70177 0.0123235C4.69399 -0.153604 6.20984 1.37898 5.97621 3.22548C5.65721 5.74674 4.90629 8.33479 4.54506 10.8634C4.13336 12.3352 1.99908 12.3838 1.48335 10.9729C1.09789 8.40972 0.352972 5.7841 0.0237493 3.22527C-0.181653 1.63007 0.964956 0.156962 2.70177 0.0123235Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.70013 13.4507C5.82695 13.0974 6.22975 17.7601 3.19852 17.9905C0.136612 18.2233 -0.139924 13.7718 2.70013 13.4507Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125375",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 6,
			height: 18,
			fill: "currentColor"
		})
	}) })]
});
export default SvgExclamationMark;
